/**
 * Componente que exibe a tela de sucesso após a desvinculação de perfil
 * Mostra uma mensagem de confirmação e um ícone de verificação para o usuário
 */
import H1 from "../../../../../components/UI/Titles/H1/h1";
import RoundedButton from "../../../../../components/Buttons/RoundedButton";
import StateView from '../shared/StateView';
import LinkMessage from '../shared/LinkMessage';
import StateIcon from '../shared/StateIcon';
import classes from '../../RescueCode.module.scss';
import UnlinkedCheck from "../../../../../assets/images/unlinked_check.svg";

/**
 * UnlinkSuccessView - Componente de visualização para o estado de desvinculação bem-sucedida
 * @param {Function} redirectToDashboard - Função para redirecionar o usuário ao painel principal
 * @returns {JSX.Element} - Tela de confirmação de desvinculação com sucesso
 */
const UnlinkSuccessView = ({ redirectToDashboard }) => {
  return (
    // Container principal usando o componente reutilizável StateView
    <StateView className={classes.unlinkSuccessContainer}>
      {/* Título principal da página */}
      <H1 className={classes.unlinkSuccessTitle}>Perfil desvinculado!</H1>

      {/* Mensagem de confirmação usando o componente reutilizável LinkMessage */}
      <LinkMessage className={classes.unlinkSuccessMessage}>
        <p>Seu perfil foi desvinculado com sucesso.</p>
      </LinkMessage>

      {/* Ícone de verificação que confirma visualmente a ação bem-sucedida */}
      <StateIcon 
        imageSrc={UnlinkedCheck}
        altText="Desvinculação bem-sucedida"
        iconContainerClass={classes.unlinkSuccessIconContainer}
        iconClass={classes.unlinkSuccessIcon}
      />

      {/* Botão para retornar ao painel principal da aplicação */}
      <RoundedButton
        className={classes.returnButton}
        text="VOLTAR AO PAINEL"
        onClick={redirectToDashboard} // Chama a função de redirecionamento ao ser clicado
      />
    </StateView>
  );
};

export default UnlinkSuccessView;